import { Flex, Text } from '@mantine/core';
import ReactCountryFlag from 'react-country-flag';
import { useMemo } from 'react';
import { extractCountryCodeFromJurisdictionCountryCode } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/common/utils.ts';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';

interface Props {
	displayName: string;
	countryCode?: string;
	regNumber?: string;
}

export const PivSummary = ({ displayName, countryCode, regNumber }: Props) => {
	const mappedCountryCode = useMemo(
		() => extractCountryCodeFromJurisdictionCountryCode(countryCode),
		[countryCode]
	);

	return (
		<Flex direction="column" pr="0.5rem" style={{ flex: 1 }}>
			<Text fz="md" c="dark.8">
				{displayName}
			</Text>
			<Flex align="center" gap="0.25rem">
				{mappedCountryCode && (
					<ReactCountryFlag
						countryCode={mappedCountryCode}
						svg
						style={{
							width: '1em',
							height: '1em',
						}}
						title={mappedCountryCode}
					/>
				)}
				<Text fz="sm" c="dark.0">
					{regNumber || LONG_DASH}
				</Text>
			</Flex>
		</Flex>
	);
};
